// extracted by mini-css-extract-plugin
module.exports = {"NoSubscriptionContainer":"SettingsSubscription_NoSubscriptionContainer__cToSg","NoSubscriptionText":"SettingsSubscription_NoSubscriptionText__q_Yjc"};